import { render, staticRenderFns } from "./leech-calculator.vue?vue&type=template&id=12cada08&scoped=true&"
import script from "./leech-calculator.vue?vue&type=script&lang=js&"
export * from "./leech-calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cada08",
  null
  
)

export default component.exports